import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./domain/queryClient";
import { initOfflineSync } from "./domain/offlineQueue";
import "./design/theme.css";
import { App } from "./app/App";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Non-fatal — app works without the SW; push notifications and offline caching degrade gracefully.
    });
  });
}

// Real offline queue sync - flush on reconnect/foreground (see offlineQueue.ts
// for why this isn't Background Sync API alone). Never torn down; the app
// root never unmounts in a real session.
initOfflineSync();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
